/*@ngInject*/
const BaseCachedRepository = function ($http, $q, $cacheFactory) {

    this.getCacheName = function () {
        return '';
    };

    this.getCacheCapacity = function () {
        return 0;
    };

    this.clearCache = function () {
        let cache = $cacheFactory.get(this.getCacheName());
        if (cache) {
            cache.removeAll();
        }
    };

    this.removeFromCache = function (cacheKey) {
        let cache = $cacheFactory.get(this.getCacheName());
        if (cache) {
            cache.remove(cacheKey);
        }
    };

    this.get = function (cacheKey, url, config) {
        let cache = $cacheFactory.get(this.getCacheName());

        function onSuccess(response) {
            let processedResponseData;

            if (response) {
                processedResponseData = this.processResponseData(_.cloneDeep(response.data));

                cache.put(cacheKey, processedResponseData);

                return processedResponseData;
            } else {
                return $q.reject();
            }
        }

        function onError(errorResponse) {
            return $q.reject(errorResponse.data);
        }

        if (!cache) {
            cache = $cacheFactory(this.getCacheName(), {capacity: this.getCacheCapacity()});
        }

        if (!_.isNil(cache.get(cacheKey))) {
            return $q.when(cache.get(cacheKey));
        }

        return $http.get(url, config).then(onSuccess.bind(this), onError);
    };

    this.processResponseData = function (responseData) {
        return responseData;
    };
};

angular.module('umCore')
    .service('baseCachedRepository', BaseCachedRepository);
